const urlTag =
  '//c.webtrends-optimize.com/acs/accounts/f0b4b5c9-b260-4ea2-af37-e6167e1ad77e/js/wt.js'
const labelCookiesConsent = '_swb_consent_'

export { labelCookiesConsent, urlTag }
